import type { FormController } from "@mittwald/flow-components/dist/components/Form";
import User from "../../../../model/user/User";
import { TariffType } from "../components/steps/TariffStep/utils/TariffUtils";
import type { RelocationFormData } from "../RelocationRequestWidget";
import type { ContractPartner } from "../types/LegacySystemAPI";
import type { ArticleNames } from "./articles";

export const isNewSystem = (
  form: FormController<RelocationFormData>,
): boolean => form.watch("target.system") === "mstudio";

export const updateInformationByUser = (
  form: FormController<RelocationFormData>,
  user: User | ContractPartner,
): void => {
  const formValues = form.getValues();

  if (user instanceof User) {
    if (formValues.contact.firstName === "") {
      form.setValue("contact.firstName", user.data.person.firstName);
    }
    if (formValues.contact.lastName === "") {
      form.setValue("contact.lastName", user.data.person.lastName);
    }
    if (formValues.contact.email === "") {
      form.setValue("contact.email", user.data.email || "");
    }
    if (formValues.contact.phoneNumber === "") {
      form.setValue("contact.phoneNumber", user.data.phoneNumber);
    }
  } else {
    if (formValues.contact.firstName === "") {
      form.setValue("contact.firstName", user.firstName);
    }
    if (formValues.contact.lastName === "") {
      form.setValue("contact.lastName", user.lastName);
    }
    if (formValues.contact.email === "") {
      form.setValue("contact.email", user.contact.email || "");
    }
    if (formValues.contact.phoneNumber === "") {
      form.setValue(
        "contact.phoneNumber",
        user.contact.telephone.split("-").join("").trim(),
      );
    }
  }
};

export const relocationFormDefaultValues = (
  user?: User,
  article?: ArticleNames,
): RelocationFormData => ({
  articleType: article || "cms-hosting",
  additionalServices: {
    dataCompare: "default",
  },
  target: {
    organisation: "-",
    organisationUUID: "",
    projectName: "",
    system: "mstudio",
    product: TariffType.SPACE_SERVER,
  },
  provider: {
    name: "",
    userName: "",
    sourceAccount: "",
    loginUrl: "",
    password: "",
  },
  contact: {
    firstName: user?.data.person.firstName || "",
    lastName: user?.data.person.lastName || "",
    email: user?.email || "",
    phoneNumber: user?.data.phoneNumber || "",
  },
  allowPasswordChange: false,
  allDomains: undefined,
  domainTransfer: "noDomainTransfer",
  domains: [],
  notes: "",
  prices: {
    positions: [],
    total: 0,
  },
  userId: user?.id ?? "",
});
